import jQuery from "jquery";
window.$ = jQuery;

String.prototype.format = function () {
    let s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp("\\{" + i + "\\}", "gm"), arguments[i]);
    }
    return s;
};

/**
 * Formats a tire size string into a display-friendly format
 * @param {string} tireSize - The tire size string to format (e.g., "205-55-16", "15-_-16", "31-10.5-15")
 * @returns {string} - The formatted tire size display text (e.g., "205/55R16", "15R16", "31x10.5R15")
 */
function formatTireSize(tireSize) {
    if (!tireSize) {
        return "";
    }

    // For normal tyre size xxx-xx-xx
    const metricRegex = /^(\d{3})-(\d{2,3})-(\d{2})$/;
    // For special tyre size like xxxRxx -> xxx-_-xx
    const specialRegex = /^(\d{1,2}(?:\.5)?)-_-(\d{2}(?:\.5)?)$/;
    // For tyre size with floats like xxx-xx.5-xx.5
    const flotationRegex = /^(\d{2})-(\d{1,2}(?:\.5)?)-(\d{2}(?:\.5)?)$/;

    if (specialRegex.test(tireSize)) {
        const [, width, rim] = tireSize.match(specialRegex);
        return `${width}R${rim}`;
    } else if (metricRegex.test(tireSize)) {
        const [, width, aspectRatio, rim] = tireSize.match(metricRegex);
        return `${width}/${aspectRatio}R${rim}`;
    } else if (flotationRegex.test(tireSize)) {
        const [, diameter, width, rim] = tireSize.match(flotationRegex);
        return `${diameter}x${width}R${rim}`;
    } else {
        // Return empty string if format is unknown
        return "";
    }
}

$("div.search-results").on("click", "#btnLoadMoreTyre", function () {
    $(".grid-footer").attr("data-page-number", parseInt($(".grid-footer").attr("data-page-number")) + 1);
    filterTyres();
});

document.addEventListener("DOMContentLoaded", function () {
    let tfCookie = window.getCookie("tireFinderData");
    try {
        const tfData = JSON.parse(decodeURIComponent(atob(tfCookie)));
        const categId = tfData.selectorType;
        const vehicleEnabled = $(".changeVehicle__actions__tirefinder .vehicle-enabled");
        const vehicleDisabled = $(".changeVehicle__actions__tirefinder .vehicle-disabled");
        const recommendationSection = $(".recommendation-section");
        const recommendedBanner = recommendationSection.find(".recommended-banner");

        vehicleEnabled.toggleClass("d-none", false);
        vehicleDisabled.toggleClass("d-none", true);
        recommendedBanner.removeClass("d-none");

        console.log(tfData);
        if (categId === "size") {
            const { tireSizeDisplay } = tfData.size;
            const { width, aspectRatio, rimDiameter } = tfData.size;

            vehicleEnabled.find("button span.caption").html("Fits your size");
            vehicleEnabled.find(".tire-vehicle-info p.tiresize-info").html("Tyre Size: {0}".format(tireSizeDisplay));
            vehicleEnabled.find("a.find-tire").html("Change Tyre Size").addClass("tireSize-Finder");
            const prevRef = [width, aspectRatio, rimDiameter];

            const params = new URLSearchParams(window.location.search);
            // Get the values
            const tireFinder = params.get("tireFinder");
            const tireSize = params.get("tireSize");
            if (tireFinder == "true" && tireSize) {
                const displayText = formatTireSize(tireSize);
                $(".js-tire-size-code").html(`${displayText}`);
                $(".category-title").html(`Tyres that fit your size ${displayText}`);

                $(".changeVehicle__actions__changetiresize .js-non-staggered-tire-fit").removeClass("d-none");
                $(".changeVehicle__actions__changetiresize .tire-vehicle-info").removeClass("d-none");
                $(".changeVehicle__actions__changetiresize .tire-vehicle-info").addClass("display-f");
                $(".changeVehicle__actions__changetiresize .js-change-tireSize-btn").toggleClass("d-none");
            }
        } else if (categId === "vehicle") {
            console.log('test');
            const variant = tfData.vehicle.refinements.variant.refDisplayValue;
            const model = tfData.vehicle.refinements.model.refDisplayValue;
            const make = tfData.vehicle.refinements.make.refDisplayValue;
            const year = tfData.vehicle.refinements.year.refDisplayValue;
            const size = tfData.vehicle.size;

            const params = new URLSearchParams(window.location.search);
            // Get the values
            const tireFinder = params.get("tireFinder");
            const vehicleId = params.get("vehicleId");

            if (tireFinder == "true" && vehicleId) {
                $(".category-title").html(`Tyres that fit your ${year} ${make} ${model} ${variant}`);
                $(".js-tire-vehicle-name").html(`${year} ${make} ${model} ${variant}`);
                $(".changeVehicle__actions__changetiresize .tire-vehicle-info").removeClass("d-none");
                $(".changeVehicle__actions__changetiresize .tire-vehicle-info").addClass("display-f");
                $(".changeVehicle__actions__changetiresize .js-change-vehicle-btn").toggleClass("d-none");
                
                //Get size and loop the array and format the tire size and display it
                const sizeText = size.map(item => formatTireSize(item)).join(", ");
                $(".changeVehicle__actions__changetiresize .js-tire-size-code").html(sizeText);
                $(".changeVehicle__actions__changetiresize .js-non-staggered-tire-fit").removeClass("d-none");
            }
        }
    } catch (error) {
        console.log("no cookie");
        tfCookie = null;
    }
});

function filterTyres() {
    let page = parseInt($(".grid-footer").attr("data-page-number") ?? 1);
    let page_size = parseInt($(".grid-footer").attr("data-page-size") ?? productObj.pagination_size);
    let category = $('#tyre-page-filter input[name="tyre-category"]').val();

    const params = new URLSearchParams(window.location.search);
    // Get the values
    const tireFinder = params.get("tireFinder") === "true";
    const tireSize = params.get("tireSize");
    const vehicleId = params.get("vehicleId");

    $.ajax({
        url: wpApiSettings.root + "goodyearforward/v1/tyres",
        method: "GET",
        data: {
            page_no: page,
            page_size: page_size,
            category: category,
            tire_size: (tireFinder && tireSize && tireSize.replace(/[^0-9\-]/g, "")) || null,
            vehicleId: (tireFinder && vehicleId && vehicleId.replace(/[^0-9\-]/g, "")) || null,
        },
        beforeSend: function (xhr) {
            xhr.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
            $(".spinner").show();
            $("#btnLoadMoreTyre").hide();
        },
        success: function (data) {
            console.log(data);
            $(".product-cards .grid-footer").before(data.data.html);

            $(".grid-footer").attr("data-page-number", data.data.current_page);

            if (data.data.current_page < data.data.total_pages) {
                $("#btnLoadMoreTyre").show();
            }
        },
        complete: function () {
            $(".spinner").hide();
        },
    });
}


//for eagle pdc
$('.product-card').each(function () {
    const link = $(this).find('.tyre-link').attr('href');

    if (link && link.indexOf('/tyres/eagle') !== -1) {
        $(this).hide();
    }
});